const _ = require('lodash')

const conversionFactors = {
  BtusPerWattHour: 3.412128,
  GramsCO2OilPerWattHour: 0.568,
  GramsCO2GasPerWattHour: 0.2536,
  GallonsPerLiter: 0.264172,
  PoundsForcePerSquareInchPerBar: 14.5037738
}

const Units = {
  units: {

    None: {
      unitId: 'None',
      unitCode: 'None',
      unitFamily: null,
      unitText: ' '
    },

    Euros: {
      unitId: 'Euros',
      unitCode: 'Euros',
      unitFamily: null,
      unitText: ' €'
    },

    Dollars: {
      unitId: 'Dollars',
      unitCode: 'Dollars',
      unitFamily: null,
      unitText: ' $'
    },

    Pounds: {
      unitId: 'Pounds',
      unitCode: 'Pounds',
      unitFamily: null,
      unitText: ' £'
    },

    Bars: {
      unitId: 'Bars',
      unitCode: 'Bars',
      unitFamily: 'Pressure',
      unitText: ' bar'
    },

    Btus: {
      unitId: 'Btus',
      unitCode: 'Btus',
      unitFamily: 'Energy',
      unitText: ' BTU'
    },

    CubicMeters: {
      unitId: 'CubicMeters',
      unitCode: 'CubicMeters',
      unitFamily: 'Volume',
      unitText: ' m³'
    },

    CubicMetersPerHour: {
      unitId: 'CubicMetersPerHour',
      unitCode: 'CubicMetersPerHour',
      unitFamily: 'VolumeFlow',
      unitText: ' m³/h'
    },

    Days: {
      unitId: 'Days',
      unitCode: 'Days',
      unitFamily: 'Time',
      unitText: ' d'
    },

    DegreesAngular: {
      unitId: 'DegreesAngular',
      unitCode: 'DegreesAngular',
      unitFamily: null,
      unitText: ' °'
    },

    DegreesCelsius: {
      unitId: 'DegreesCelsius',
      unitCode: 'DegreesCelsius',
      unitFamily: 'Temperature',
      unitText: ' °C'
    },

    DegreesFahrenheit: {
      unitId: 'DegreesFahrenheit',
      unitCode: 'DegreesFahrenheit',
      unitFamily: 'Temperature',
      unitText: ' °F'
    },

    DegreesKelvin: {
      unitId: 'DegreesKelvin',
      unitCode: 'DegreesKelvin',
      unitFamily: null,
      unitText: ' K'
    },

    Gallons: {
      unitId: 'Gallons',
      unitCode: 'Gallons',
      unitFamily: 'Volume',
      unitText: ' gal'
    },

    GallonsPerHour: {
      unitId: 'GallonsPerHour',
      unitCode: 'GallonsPerHour',
      unitFamily: 'VolumeFlow',
      unitText: ' gal/h'
    },

    GallonsPerMinute: {
      unitId: 'GallonsPerMinute',
      unitCode: 'GallonsPerMinute',
      unitFamily: 'VolumeFlow',
      unitText: ' gal/min'
    },

    GramsCO2Gas: {
      unitId: 'GramsCO2Gas',
      unitCode: 'GramsCO2Gas',
      unitFamily: 'Energy',
      unitText: ' g CO₂ (Gas)'
    },

    GramsCO2Oil: {
      unitId: 'GramsCO2Oil',
      unitCode: 'GramsCO2Oil',
      unitFamily: 'Energy',
      unitText: ' g CO₂ (Oil)'
    },

    Hectopascals: {
      unitId: 'Hectopascals',
      unitCode: 'Hectopascals',
      unitFamily: null,
      unitText: ' hPa'
    },

    Hertz: {
      unitId: 'Hertz',
      unitCode: 'Hertz',
      unitFamily: null,
      unitText: ' Hz'
    },

    Hours: {
      unitId: 'Hours',
      unitCode: 'Hours',
      unitFamily: 'Time',
      unitText: ' h'
    },

    KiloBtus: {
      unitId: 'KiloBtus',
      unitCode: 'KiloBtus',
      unitFamily: 'Energy',
      unitText: ' MBTU'
    },

    KiloWattHoursPerSquareMeterPerDay: {
      unitId: 'KiloWattHoursPerSquareMeterPerDay',
      unitCode: 'KiloWattHoursPerSquareMeterPerDay',
      unitFamily: null,
      unitText: ' kWh/(m²*d)'
    },

    KilogramsCO2Gas: {
      unitId: 'KilogramsCO2Gas',
      unitCode: 'KilogramsCO2Gas',
      unitFamily: 'Energy',
      unitText: ' kg CO₂ (Gas)'
    },

    KilogramsCO2Oil: {
      unitId: 'KilogramsCO2Oil',
      unitCode: 'KilogramsCO2Oil',
      unitFamily: 'Energy',
      unitText: ' kg CO₂ (Oil)'
    },

    KilogramsPerCubicMeter: {
      unitId: 'KilogramsPerCubicMeter',
      unitCode: 'KilogramsPerCubicMeter',
      unitFamily: null,
      unitText: ' kg/m³'
    },

    KilogramsPerHour: {
      unitId: 'KilogramsPerHour',
      unitCode: 'KilogramsPerHour',
      unitFamily: null,
      unitText: ' kg/h'
    },

    KilowattHours: {
      unitId: 'KilowattHours',
      unitCode: 'KilowattHours',
      unitFamily: 'Energy',
      unitText: ' kWh'
    },

    Kilowatts: {
      unitId: 'Kilowatts',
      unitCode: 'Kilowatts',
      unitFamily: 'Power',
      unitText: ' kW'
    },

    Liters: {
      unitId: 'Liters',
      unitCode: 'Liters',
      unitFamily: 'Volume',
      unitText: ' l'
    },

    LitersPerHour: {
      unitId: 'LitersPerHour',
      unitCode: 'LitersPerHour',
      unitFamily: 'VolumeFlow',
      unitText: ' l/h'
    },

    LitersPerMinute: {
      unitId: 'LitersPerMinute',
      unitCode: 'LitersPerMinute',
      unitFamily: 'VolumeFlow',
      unitText: ' l/min'
    },

    LitersPerSquareMeterPerDay: {
      unitId: 'LitersPerSquareMeterPerDay',
      unitCode: 'LitersPerSquareMeterPerDay',
      unitFamily: null,
      unitText: ' l/(m²*d)'
    },

    MegaBtus: {
      unitId: 'MegaBtus',
      unitCode: 'MegaBtus',
      unitFamily: 'Energy',
      unitText: ' MMBTU'
    },

    MegawattHours: {
      unitId: 'MegawattHours',
      unitCode: 'MegawattHours',
      unitFamily: 'Energy',
      unitText: ' MWh'
    },

    MetersPerSecond: {
      unitId: 'MetersPerSecond',
      unitCode: 'MetersPerSecond',
      unitFamily: null,
      unitText: ' m/s'
    },

    Milliamperes: {
      unitId: 'Milliamperes',
      unitCode: 'Milliamperes',
      unitFamily: null,
      unitText: ' mA'
    },

    Milliseconds: {
      unitId: 'Milliseconds',
      unitCode: 'Milliseconds',
      unitFamily: null,
      unitText: ' ms'
    },

    Minutes: {
      unitId: 'Minutes',
      unitCode: 'Minutes',
      unitFamily: 'Time',
      unitText: ' min'
    },

    Ohms: {
      unitId: 'Ohms',
      unitCode: 'Ohms',
      unitFamily: null,
      unitText: ' Ω'
    },

    Percent: {
      unitId: 'Percent',
      unitCode: 'Percent',
      unitFamily: null,
      unitText: '%'
    },

    PoundsForcePerSquareInch: {
      unitId: 'PoundsForcePerSquareInch',
      unitCode: 'PoundsForcePerSquareInch',
      unitFamily: 'Pressure',
      unitText: ' psi'
    },

    Seconds: {
      unitId: 'Seconds',
      unitCode: 'Seconds',
      unitFamily: 'Time',
      unitText: ' s'
    },

    SquareMeters: {
      unitId: 'SquareMeters',
      unitCode: 'SquareMeters',
      unitFamily: null,
      unitText: ' m²'
    },

    TonsCO2Gas: {
      unitId: 'TonsCO2Gas',
      unitCode: 'TonsCO2Gas',
      unitFamily: 'Energy',
      unitText: ' t CO₂ (Gas)'
    },

    TonsCO2Oil: {
      unitId: 'TonsCO2Oil',
      unitCode: 'TonsCO2Oil',
      unitFamily: 'Energy',
      unitText: ' t CO₂ (Oil)'
    },

    Volts: {
      unitId: 'Volts',
      unitCode: 'Volts',
      unitFamily: null,
      unitText: ' V'
    },

    WattHours: {
      unitId: 'WattHours',
      unitCode: 'WattHours',
      unitFamily: 'Energy',
      unitText: ' Wh'
    },

    Watts: {
      unitId: 'Watts',
      unitCode: 'Watts',
      unitFamily: 'Power',
      unitText: ' W'
    },

    WattsPerSquareMeter: {
      unitId: 'WattsPerSquareMeter',
      unitCode: 'WattsPerSquareMeter',
      unitFamily: null,
      unitText: ' W/m²'
    },

    PercentRelativeHumidity: {
      unitId: 'PercentRelativeHumidity',
      unitCode: 'PercentRelativeHumidity',
      unitFamily: null,
      unitText: '%RH'
    }
  },

  getUnitFamilyFromUnitCode (unitCode) {
    let unitFamily = null
    Object.getOwnPropertyNames(Units.units).forEach(unit => {
      if (Units.units[unit] && unitCode === Units.units[unit].unitCode) {
        // console.log(Units.units[unit])
        unitFamily = Units.units[unit].unitFamily
      }
    })
    return unitFamily
  },

  /**
   * Converts a raw number value from one unit to another. The units must be in the same unit family.
   *
   * @param {number} rawValue Raw number value to convert from
   * @param {Unit} sourceUnit Unit to convert from
   * @param {Unit} targetUnit Unit to convert to
   * @return {object} Result containing a `rawValue` property with the conversion result and a `unit` property with the associated unit.
   */
  convertRawValue: function (rawValue_, sourceUnit_, targetUnit_) {
    let conversions
    if (_.isArray(sourceUnit_)) {
      conversions = sourceUnit_
    } else {
      conversions = [{
        power: null,
        factor: null,
        offset: null,
        sourceUnit: sourceUnit_,
        targetUnit: targetUnit_
      }]
    }

    let result = _.reduce(conversions, function (valueInfo, conversion) {
      let rawValue = valueInfo.rawValue
      let sourceUnit = conversion.sourceUnit
      let targetUnit = conversion.targetUnit
      let unitFamily = sourceUnit && sourceUnit.unitFamily

      let hasPower = _.isNumber(conversion.power)
      let hasFactor = _.isNumber(conversion.factor)
      let hasOffset = _.isNumber(conversion.offset)
      let autoConvert = !hasFactor && !hasOffset && !hasPower

      if (hasPower) {
        if (rawValue !== 0) {
          rawValue = Math.pow(rawValue, conversion.power)
        }
      }
      if (hasFactor) {
        rawValue = rawValue * conversion.factor
      }
      if (hasOffset) {
        rawValue = rawValue + conversion.offset
      }

      if (autoConvert && !sourceUnit) {
        throw new Error('Must provide a source unit')
      } else if (!targetUnit) {
        // nop, no conversion requested
      } else if (sourceUnit.unitCode === targetUnit.unitCode) {
        // nop, no conversion for same unit
      } else if (targetUnit.unitCode === 'None') {
        // nop, just ignore the unit suffix
      } else if (!autoConvert) {
        // nop, already multiplied by factor above and allows to change unit family
      } else if (unitFamily !== targetUnit.unitFamily) {
        throw new Error('Unit families of source and target unit must match')
      } else if (!unitFamily) {
        // nop, no conversion for unknown unit family
      } else if (unitFamily === 'Temperature') {
        rawValue = Units._convertTemperatureRawValue(rawValue, sourceUnit.unitCode, targetUnit.unitCode)
      } else if (unitFamily === 'Volume') {
        rawValue = Units._convertVolumeRawValue(rawValue, sourceUnit.unitCode, targetUnit.unitCode)
      } else if (unitFamily === 'VolumeFlow') {
        rawValue = Units._convertVolumeFlowRawValue(rawValue, sourceUnit.unitCode, targetUnit.unitCode)
      } else if (unitFamily === 'Pressure') {
        rawValue = Units._convertPressureRawValue(rawValue, sourceUnit.unitCode, targetUnit.unitCode)
      } else if (unitFamily === 'Energy') {
        rawValue = Units._convertEnergyRawValue(rawValue, sourceUnit.unitCode, targetUnit.unitCode)
      } else if (unitFamily === 'Power') {
        rawValue = Units._convertPowerRawValue(rawValue, sourceUnit.unitCode, targetUnit.unitCode)
      } else if (unitFamily === 'Time') {
        rawValue = Units._convertTimeRawValue(rawValue, sourceUnit.unitCode, targetUnit.unitCode)
      } else {
        throw new Error('Unsupported unit family ' + JSON.stringify(sourceUnit.unitFamily))
      }

      return {
        rawValue: rawValue,
        unit: targetUnit || sourceUnit
      }
    }, {
      rawValue: rawValue_,
      unit: sourceUnit_
    })

    return result
  },

  _convertTemperatureRawValue: function (rawValue, sourceUnitCode, targetUnitCode) {
    switch (sourceUnitCode) {
      case 'DegreesCelsius':
        // nop
        break
      case 'DegreesFahrenheit':
        rawValue = (rawValue - 32) / 1.8
        break
      default:
        throw new Error('Unsupported source unit ' + JSON.stringify(sourceUnitCode))
    }

    switch (targetUnitCode) {
      case 'DegreesCelsius':
        // nop
        break
      case 'DegreesFahrenheit':
        rawValue = (rawValue * 1.8) + 32
        break
      default:
        throw new Error('Unsupported target unit ' + JSON.stringify(targetUnitCode))
    }

    return rawValue
  },

  getConversionsTemperatureRawValue: function (rawValue, sourceUnitCode, targetUnitCode) {
    switch (sourceUnitCode) {
      case 'DegreesCelsius':
        // nop
        break
      case 'DegreesFahrenheit':

        rawValue = (rawValue - 32) / 1.8
        break
      default:
        throw new Error('Unsupported source unit ' + JSON.stringify(sourceUnitCode))
    }

    switch (targetUnitCode) {
      case 'DegreesCelsius':
        // nop
        break
      case 'DegreesFahrenheit':
        rawValue = (rawValue * 1.8) + 32
        break
      default:
        throw new Error('Unsupported target unit ' + JSON.stringify(targetUnitCode))
    }

    return rawValue
  },

  _convertVolumeRawValue: function (rawValue, sourceUnitCode, targetUnitCode) {
    switch (sourceUnitCode) {
      case 'Liters':
        // nop
        break
      case 'CubicMeters':
        rawValue = rawValue * 1000
        break
      case 'Gallons':
        rawValue = rawValue / conversionFactors.GallonsPerLiter
        break
      default:
        throw new Error('Unsupported source unit ' + JSON.stringify(sourceUnitCode))
    }

    switch (targetUnitCode) {
      case 'Liters':
        // nop
        break
      case 'CubicMeters':
        rawValue = rawValue / 1000
        break
      case 'Gallons':
        rawValue = rawValue * conversionFactors.GallonsPerLiter
        break
      default:
        throw new Error('Unsupported target unit ' + JSON.stringify(targetUnitCode))
    }

    return rawValue
  },

  _convertVolumeFlowRawValue: function (rawValue, sourceUnitCode, targetUnitCode) {
    switch (sourceUnitCode) {
      case 'LitersPerHour':
        // nop
        break
      case 'LitersPerMinute':
        rawValue = rawValue * 60
        break
      case 'CubicMetersPerHour':
        rawValue = rawValue * 1000
        break
      case 'GallonsPerHour':
        rawValue = rawValue / conversionFactors.GallonsPerLiter
        break
      case 'GallonsPerMinute':
        rawValue = rawValue * 60 / conversionFactors.GallonsPerLiter
        break
      default:
        throw new Error('Unsupported source unit ' + JSON.stringify(sourceUnitCode))
    }

    switch (targetUnitCode) {
      case 'LitersPerHour':
        // nop
        break
      case 'LitersPerMinute':
        rawValue = rawValue / 60
        break
      case 'CubicMetersPerHour':
        rawValue = rawValue / 1000
        break
      case 'GallonsPerHour':
        rawValue = rawValue * conversionFactors.GallonsPerLiter
        break
      case 'GallonsPerMinute':
        rawValue = rawValue / 60 * conversionFactors.GallonsPerLiter
        break
      default:
        throw new Error('Unsupported target unit ' + JSON.stringify(targetUnitCode))
    }

    return rawValue
  },

  _convertPressureRawValue: function (rawValue, sourceUnitCode, targetUnitCode) {
    switch (sourceUnitCode) {
      case 'Bars':
        // nop
        break
      case 'PoundsForcePerSquareInch':
        rawValue = rawValue / conversionFactors.PoundsForcePerSquareInchPerBar
        break
      default:
        throw new Error('Unsupported source unit ' + JSON.stringify(sourceUnitCode))
    }

    switch (targetUnitCode) {
      case 'Bars':
        // nop
        break
      case 'PoundsForcePerSquareInch':
        rawValue = rawValue * conversionFactors.PoundsForcePerSquareInchPerBar
        break
      default:
        throw new Error('Unsupported target unit ' + JSON.stringify(targetUnitCode))
    }

    return rawValue
  },

  _convertEnergyRawValue: function (rawValue, sourceUnitCode, targetUnitCode) {
    switch (sourceUnitCode) {
      case 'WattHours':
        // nop
        break
      case 'KilowattHours':
        rawValue = rawValue * 1000
        break
      case 'MegawattHours':
        rawValue = rawValue * 1000000
        break
      case 'Btus':
        rawValue = rawValue / conversionFactors.BtusPerWattHour
        break
      case 'KiloBtus':
        rawValue = rawValue * 1000 / conversionFactors.BtusPerWattHour
        break
      case 'MegaBtus':
        rawValue = rawValue * 1000000 / conversionFactors.BtusPerWattHour
        break
      case 'GramsCO2Gas':
        rawValue = rawValue / conversionFactors.GramsCO2GasPerWattHour
        break
      case 'KilogramsCO2Gas':
        rawValue = rawValue * 1000 / conversionFactors.GramsCO2GasPerWattHour
        break
      case 'TonsCO2Gas':
        rawValue = rawValue * 1000000 / conversionFactors.GramsCO2GasPerWattHour
        break
      case 'GramsCO2Oil':
        rawValue = rawValue / conversionFactors.GramsCO2OilPerWattHour
        break
      case 'KilogramsCO2Oil':
        rawValue = rawValue * 1000 / conversionFactors.GramsCO2OilPerWattHour
        break
      case 'TonsCO2Oil':
        rawValue = rawValue * 1000000 / conversionFactors.GramsCO2OilPerWattHour
        break
      default:
        throw new Error('Unsupported source unit ' + JSON.stringify(sourceUnitCode))
    }

    switch (targetUnitCode) {
      case 'WattHours':
        // nop
        break
      case 'KilowattHours':
        rawValue = rawValue / 1000
        break
      case 'MegawattHours':
        rawValue = rawValue / 1000000
        break
      case 'Btus':
        rawValue = rawValue * conversionFactors.BtusPerWattHour
        break
      case 'KiloBtus':
        rawValue = rawValue / 1000 * conversionFactors.BtusPerWattHour
        break
      case 'MegaBtus':
        rawValue = rawValue / 1000000 * conversionFactors.BtusPerWattHour
        break
      case 'GramsCO2Gas':
        rawValue = rawValue * conversionFactors.GramsCO2GasPerWattHour
        break
      case 'KilogramsCO2Gas':
        rawValue = rawValue / 1000 * conversionFactors.GramsCO2GasPerWattHour
        break
      case 'TonsCO2Gas':
        rawValue = rawValue / 1000000 * conversionFactors.GramsCO2GasPerWattHour
        break
      case 'GramsCO2Oil':
        rawValue = rawValue * conversionFactors.GramsCO2OilPerWattHour
        break
      case 'KilogramsCO2Oil':
        rawValue = rawValue / 1000 * conversionFactors.GramsCO2OilPerWattHour
        break
      case 'TonsCO2Oil':
        rawValue = rawValue / 1000000 * conversionFactors.GramsCO2OilPerWattHour
        break
      default:
        throw new Error('Unsupported target unit ' + JSON.stringify(targetUnitCode))
    }

    return rawValue
  },

  _convertPowerRawValue: function (rawValue, sourceUnitCode, targetUnitCode) {
    switch (sourceUnitCode) {
      case 'Watts':
        // nop
        break
      case 'Kilowatts':
        rawValue = rawValue * 1000
        break
      default:
        throw new Error('Unsupported source unit ' + JSON.stringify(sourceUnitCode))
    }

    switch (targetUnitCode) {
      case 'Watts':
        // nop
        break
      case 'Kilowatts':
        rawValue = rawValue / 1000
        break
      default:
        throw new Error('Unsupported target unit ' + JSON.stringify(targetUnitCode))
    }

    return rawValue
  },

  _convertTimeRawValue: function (rawValue, sourceUnitCode, targetUnitCode) {
    switch (sourceUnitCode) {
      case 'Seconds':
        // nop
        break
      case 'Minutes':
        rawValue = rawValue * 60
        break
      case 'Hours':
        rawValue = rawValue * 3600
        break
      case 'Days':
        rawValue = rawValue * 86400
        break
      default:
        throw new Error('Unsupported source unit ' + JSON.stringify(sourceUnitCode))
    }

    switch (targetUnitCode) {
      case 'Seconds':
        // nop
        break
      case 'Minutes':
        rawValue = rawValue / 60
        break
      case 'Hours':
        rawValue = rawValue / 3600
        break
      case 'Days':
        rawValue = rawValue / 86400
        break
      default:
        throw new Error('Unsupported target unit ' + JSON.stringify(targetUnitCode))
    }

    return rawValue
  }
}

module.exports = Units



// WEBPACK FOOTER //
// ./src/client/lib/units.js